const QualityExpertiseSectionSkeleton = () => {
  return (
    <section className="container max-w-full py-4 md:py-8 bg-white">
      <div className="mb-3 sm:mb-5 flex items-center justify-between">
        <div className="h-7 md:h-8 w-48 md:w-64 bg-gray-200 animate-pulse rounded" />
      </div>
      <div className="flex gap-5 overflow-hidden">
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className="flex-shrink-0 w-full sm:max-w-[420px] aspect-[420/240] bg-gray-200 animate-pulse rounded-[24px]"
          />
        ))}
      </div>
    </section>
  )
}

export default QualityExpertiseSectionSkeleton
